// singleton class for the services data http calls to the API

import { BaseService } from './base-service';
import { getHTTPHeaders } from '../helpers/utils';

class MUPService extends BaseService {
    constructor() {
        super();
    }

    ///// MUP Templates /////
    getTemplates(filterObj) {
        return new Promise((resolve, reject) => {
            this.$http.get(`mup-templates?company_id=${filterObj.company_id}&area_id=${filterObj.area_id}&site_id=${filterObj.site_id}`, 
                getHTTPHeaders()
            )
                .then((response) => {
                    resolve(response.data.mup_templates);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    getTemplate(id) {
        return new Promise((resolve, reject) => {
            this.$http.get(`mup-template/${id}`, 
                getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == 'true') {
                        resolve(response.data.mup_template);
                    }
                    else {
                        reject('Error retreiving template');
                    }
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    getDefaultTemplate(siteId) {
        return new Promise((resolve, reject) => {
            this.$http.get(`mup-template/default/${siteId}`, 
                getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == true) {
                        resolve(response.data.mup_template);
                    }
                    else {
                        reject('Error retreiving template');
                    }
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    updateTemplate(template, id) {
        return new Promise((resolve, reject) => {
            this.$http.put(`mup-template/${id}`, {
                mup_template: template
              },
              getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }

    setDefaultMUPTemplateStatus(template, id) {
        return new Promise((resolve, reject) => {
            this.$http.put(`mup-template/${id}`, {
                is_default: template.is_default,
                template_name: template.template_name
              },
              getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }

    createTemplate(template) {
        return new Promise((resolve, reject) => {
            this.$http.post('mup-template', {
                template: template
              },
              getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }

    undeleteTemplate(id) {
        return new Promise((resolve, reject) => {
            this.$http.put(`mup-template/undelete/${id}`, null, getHTTPHeaders())
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }

    deleteTemplate(id) {
        return new Promise((resolve, reject) => {
            this.$http.delete(`mup-template/${id}`, getHTTPHeaders())
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }


    ///// MUP Template Plate Sizes /////
    getAvailablePlateSizesList() {
        return new Promise((resolve, reject) => {
            this.$http.get("plates/sizes", getHTTPHeaders())
                .then(response => {
                    resolve(response.data.plate_sizes);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
          });
    }

    getCurrentPlateSizes = (templateId) => {
        return new Promise((resolve, reject) => {
            this.$http.get("mup-template/sizes/" + templateId, getHTTPHeaders())
                .then(response => {
                    resolve(response.data.sizes);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
            });
    };

    addPlateSizeToTemplate = (plateSizeObj) => {
        return new Promise((resolve, reject) => {
            this.$http.post('mup-template/size', plateSizeObj, getHTTPHeaders())
            .then(response => {
                resolve(response.data.success);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
        });
    }

    plateSizeDeleteCheck = (templateId, plateSizeId) => {
        return new Promise((resolve, reject) => {
            this.$http.get(`mup-template/sizes/delete-check/${templateId}/${plateSizeId}`, getHTTPHeaders())
            .then(response => {
                resolve(response.data.template_default);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
        })
    }

    deletePlateSizeFromTemplate(templateId, plateSizeId) {
        return new Promise((resolve, reject) => {
            this.$http.delete(`mup-template/size/${templateId}/${plateSizeId}`, getHTTPHeaders())
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }

    ///// MUP Orders /////
    createOrder(order) {
        return new Promise((resolve, reject) => {
            this.$http.post('mup-order', {
                order: order
              },
              getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == true) {
                        resolve(response);
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }

    getOrders(filterObj) {
        return new Promise((resolve, reject) => {
            this.$http.get(`mup-orders?company_id=${filterObj.company_id}&area_id=${filterObj.area_id}&site_id=${filterObj.site_id}`, 
                getHTTPHeaders()
            )
                .then((response) => {
                    resolve(response.data.mup_orders);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    ///// MUP Flags /////
    getFlags() {
        return new Promise((resolve, reject) => {
            this.$http.get('plate-flags', getHTTPHeaders())
                .then((response) => {
                    resolve(response.data.plate_flags);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }
}

export default new MUPService();